"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var BarMoveRight_exports = {};
__export(BarMoveRight_exports, {
  default: () => BarMoveRight_default
});
module.exports = __toCommonJS(BarMoveRight_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.93359 13.7266L13.3711 10.25L9.93359 6.77344C9.7513 6.60417 9.66016 6.39583 9.66016 6.14844C9.66016 5.90104 9.7513 5.6862 9.93359 5.50391C10.1029 5.33464 10.3047 5.25 10.5391 5.25C10.7865 5.25 11.0013 5.33464 11.1836 5.50391L15.2461 9.625C15.4154 9.79427 15.5 10.0026 15.5 10.25C15.5 10.4974 15.4154 10.7057 15.2461 10.875L11.1836 14.9961C11.0013 15.1654 10.7865 15.25 10.5391 15.25C10.3047 15.25 10.1029 15.1654 9.93359 14.9961C9.7513 14.8138 9.66016 14.599 9.66016 14.3516C9.66016 14.1042 9.7513 13.8958 9.93359 13.7266ZM6.33984 5.25C6.5612 5.25 6.75 5.33464 6.90625 5.50391C7.07552 5.66016 7.16016 5.85547 7.16016 6.08984V14.4102C7.16016 14.6445 7.07552 14.8464 6.90625 15.0156C6.75 15.1719 6.5612 15.25 6.33984 15.25C6.10547 15.25 5.90365 15.1719 5.73438 15.0156C5.57812 14.8464 5.5 14.6445 5.5 14.4102V6.08984C5.5 5.85547 5.57812 5.66016 5.73438 5.50391C5.90365 5.33464 6.10547 5.25 6.33984 5.25Z",
      fill: "currentColor"
    }
  )
);
const SvgBarMoveRight = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var BarMoveRight_default = SvgBarMoveRight;
